const LOCALES = {
    de: 'de_DE',
    en: 'en_US',
    es: 'es_ES',
    fr: 'fr_FR',
    it: 'it_IT',
    jp: 'ja_JP',
    pl: 'pl_PL'
};

const getLanguageLocale = (lang) => {
    return LOCALES[lang] || 'en_US';
};

const updateMetadata = (t, currentLang) => {
    // Update HTML lang attribute
    document.documentElement.setAttribute('lang', currentLang);

    // Update title
    document.title = t('meta.title');

    // Update meta tags
    const metaSelectors = {
        'meta[name="subtitle"]': t('meta.subtitle'),
        'meta[name="description"]': t('meta.description'),
        'meta[property="og:title"]': t('meta.title'),
        'meta[property="og:description"]': t('meta.description'),
        'meta[property="og:site_name"]': t('meta.title'),
        'meta[property="og:locale"]': getLanguageLocale(currentLang)
    };

    // Update each meta tag
    Object.entries(metaSelectors).forEach(([selector, content]) => {
        const element = document.querySelector(selector);
        if (element) {
            element.setAttribute('content', content);
        }
    });

    // Update noscript content
    const noscript = document.querySelector('noscript');
    if (noscript) {
        noscript.textContent = t('meta.noscript');
    }
};

export default updateMetadata;